// extracted by mini-css-extract-plugin
module.exports = {"Status":"Status_Status__1G8jl","title":"Status_title__3osoo","icon":"Status_icon__24AjA","fullHeight":"Status_fullHeight__1eQbs"};